import { Autocomplete, Checkbox, MenuItem, Select } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axiosInstance from "../Axios";
import useAuth from "../contexts/UserContext.tsx";

export default function AddDashboardUser() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [newUserData, setNewUserData] = useState({
    user_fname: "",
    user_lname: "",
    user_pwd: "",
    view_access_list: {},
  });
  const [districts, setDistricts] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [selectedDistrictsString, setSelectedDistrictsString] = useState("");
  const [schoolTypes, setSchoolTypes] = useState([]);
  const [selectedSchoolTypes, setSelectedSchoolTypes] = useState([]);
  const [selectedSchoolTypesString, setSelectedSchoolTypesString] =
    useState("");
  const [schools, setSchools] = useState([]);
  const [, setSelectedSchools] = useState([]);
  const [viewAccessList, setViewAccessList] = useState({
    isEvaluator: true,
    isWrite: true,
    isIndividualSchool: true,
    smartclass: false,
    mathlab: false,
    school_types: null,
    district: null,
  });

  const getDistricts = async () => {
    var district_array = user.view_access_list.district.split(",");
    //Remove the duplicate values from the array
    district_array = district_array
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((district) => district.replace(/['"]+/g, ""))
      .sort();
    setDistricts(district_array);
  };

  const getSchoolTypes = async () => {
    const districtQuery = selectedDistricts
      .map((district) => (district = `"${district}"`))
      .join(",");
    setSelectedDistrictsString(districtQuery);
    // axiosInstance
    //   .get(
    //     `getSchoolType?district=${districtQuery}&auth_token=${user.auth_token}`
    //   )
    //   .then((res) => {
    //     setSchoolTypes(res.data.data.data)
    //   })
    //   .catch((err) => {
    //     toast.error(err);
    //   });

    //Can implement intersection between the received and access list school types but the api was not giving the types which were present in access list hence I directly decided to show the access list school types.

    var schoolTypes = user.view_access_list.school_types.split(",");
    //Remove the duplicate values from the array
    schoolTypes = schoolTypes
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((schoolType) => schoolType.replace(/['"]+/g, ""))
      .sort();
    setSchoolTypes(schoolTypes);
  };

  const getSchools = async () => {
    const schoolTypeQuery = selectedSchoolTypes
      .map((schoolType) => (schoolType = `"${schoolType}"`))
      .join(",");
    setSelectedSchoolTypesString(schoolTypeQuery);
    axiosInstance
      .get(
        `getSchools?district=${selectedDistrictsString}&school_type=${schoolTypeQuery}&auth_token=${user.auth_token}`
      )
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setSchools(res.data.data.data);
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user.user_type !== "admin") {
      return navigate("/");
    }
    getDistricts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const constructAccessList = (
    selectedSchoolStr,
    receivedSchoolTypes = selectedSchoolTypes
      .map((schoolType) => (schoolType = `"${schoolType}"`))
      .join(",")
  ) => {
    let distStr = selectedDistrictsString.replace(/"/g, "");
    let schoolTypeStr = selectedSchoolTypesString.replace(/"/g, "");
    let receivedSchoolTypesStr = receivedSchoolTypes.replace(/"/g, "");
    selectedSchoolStr = selectedSchoolStr.replace(/"/g, "");

    if (selectedSchoolStr === "") {
      setViewAccessList((prev) => {
        const { schoolID, ...rest } = prev;
        return {
          ...rest,
          school_types: receivedSchoolTypesStr,
          district: distStr,
          isIndividualSchool: false,
          isEvaluator: true,
          isWrite: true,
        };
      });
    } else {
      setViewAccessList((prev) => {
        const { schoolID, ...rest } = prev;
        return {
          ...rest,
          schoolID: parseInt(selectedSchoolStr),
          school_types: schoolTypeStr,
          district: distStr,
          isIndividualSchool: true,
          isEvaluator: true,
          isWrite: true,
        };
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      newUserData.user_fname === "" ||
      newUserData.user_lname === "" ||
      newUserData.user_pwd === "" ||
      viewAccessList.district === null ||
      viewAccessList.school_types === null
    ) {
      toast.error("Please fill all fields");
      return;
    } else if (!viewAccessList.smartclass && !viewAccessList.mathlab) {
      toast.error("Please select at least one access");
      return;
    }
    toast.info("Adding user...");

    console.log({ ...newUserData, view_access_list: viewAccessList });
    await axiosInstance
      .post("/addDashboardUser", {
        ...newUserData,
        school_id: viewAccessList.schoolID,
        view_access_list: viewAccessList,
        auth_token: user.auth_token,
      })
      .then((res) => {
        toast.success("User added successfully");
        navigate("/dashboardUsers");
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleChange = (event) => {
    setViewAccessList({
      ...viewAccessList,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <>
      <Paper elevation={3} className="w-fit mx-auto mt-10 px-10 max-w-lg">
        <h1 className="text-center p-4 font-semibold text-2xl text-green-600">
          Add Dashboard User
        </h1>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1, width: "40ch" },
          }}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col">
            <TextField
              onChange={(e) =>
                setNewUserData({ ...newUserData, user_fname: e.target.value })
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#4CAF50",
                    color: "#4CAF50",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4CAF50",
                },
              }}
              name="user_fname"
              label="First Name"
            />
            <TextField
              onChange={(e) =>
                setNewUserData({ ...newUserData, user_lname: e.target.value })
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#4CAF50",
                    color: "#4CAF50",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4CAF50",
                },
              }}
              name="user_lname"
              label="Last Name"
            />
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#4CAF50",
                    color: "#4CAF50",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#4CAF50",
                },
              }}
              onChange={(e) =>
                setNewUserData({ ...newUserData, user_pwd: e.target.value })
              }
              name="user_pwd"
              label="Password"
              type="password"
            />
            <div className="flex flex-col justify-center gap-2 w-[370px] mx-auto">
              <Select
                className="form-control"
                id="district"
                multiple
                sx={{ paddingX: "0px", height: "40px" }}
                value={districts}
                defaultValue={"Select Districts"}
                onClose={() => {
                  if (selectedDistricts.length === 0) return;
                  setSelectedSchoolTypes([]);
                  getSchoolTypes();
                }}
                renderValue={() => {
                  if (selectedDistricts.length === 0) {
                    return (
                      <span className="text-gray-500">Select Districts</span>
                    );
                  }
                  return selectedDistricts.join(", ");
                }}
              >
                <MenuItem
                  key="select-all"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedDistricts(districts);
                    } else {
                      setSelectedDistricts([]);
                    }
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        indeterminate={
                          selectedDistricts.length > 0 &&
                          selectedDistricts.length < districts.length
                        }
                        checked={selectedDistricts.length === districts.length}
                      />
                    }
                    label="Select All"
                  />
                </MenuItem>
                {districts.map((district, index) => (
                  <MenuItem key={index} value={district}>
                    <FormControlLabel
                      className="w-full"
                      control={
                        <Checkbox
                          checked={selectedDistricts.includes(district)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedDistricts([
                                ...selectedDistricts,
                                district,
                              ]);
                            } else {
                              setSelectedDistricts(
                                selectedDistricts.filter(
                                  (dist) => dist !== district
                                )
                              );
                            }
                          }}
                        />
                      }
                      label={district}
                    />
                  </MenuItem>
                ))}
              </Select>

              {/* School types dropdown */}
              <Select
                className="form-control"
                id="schoolType"
                multiple
                displayEmpty
                onClose={() => {
                  if (selectedSchoolTypes.length === 0) return;
                  setSelectedSchools([]);
                  constructAccessList(
                    "",
                    selectedSchoolTypes
                      .map((schoolType) => (schoolType = `"${schoolType}"`))
                      .join(",")
                  );
                  getSchools();
                }}
                sx={{ paddingX: "0px", height: "40px" }}
                defaultValue={""}
                disabled={selectedDistricts.length === 0}
                value={schoolTypes}
                renderValue={() => {
                  if (selectedSchoolTypes.length === 0) {
                    return (
                      <span className="text-gray-500">Select School Types</span>
                    );
                  }
                  return selectedSchoolTypes.join(", ");
                }}
              >
                <MenuItem
                  key="select-all"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedSchoolTypes(schoolTypes);
                    } else {
                      setSelectedSchoolTypes([]);
                    }
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        indeterminate={
                          selectedSchoolTypes.length > 0 &&
                          selectedSchoolTypes.length < schoolTypes.length
                        }
                        checked={
                          selectedSchoolTypes.length === schoolTypes.length
                        }
                      />
                    }
                    label="Select All"
                  />
                </MenuItem>
                {schoolTypes &&
                  schoolTypes.map((schoolType, index) => (
                    <MenuItem key={index} value={schoolType}>
                      <FormControlLabel
                        className="w-full"
                        control={
                          <Checkbox
                            checked={selectedSchoolTypes.includes(schoolType)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedSchoolTypes([
                                  ...selectedSchoolTypes,
                                  schoolType,
                                ]);
                              } else {
                                setSelectedSchoolTypes(
                                  selectedSchoolTypes.filter(
                                    (dist) => dist !== schoolType
                                  )
                                );
                              }
                            }}
                          />
                        }
                        label={schoolType}
                      />
                    </MenuItem>
                  ))}
              </Select>

              {/* Schools dropdown */}
              <Autocomplete
                options={schools || []}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                fullWidth
                onChange={(e, option) => {
                  if (option === null) {
                    setSelectedSchools("");
                    constructAccessList("");
                  } else {
                    setSelectedSchools(option.id);
                    constructAccessList(option.id);
                  }
                }}
                disabled={selectedSchoolTypes.length === 0}
                renderInput={(params) => (
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "40px",
                        padding: "0px",
                        width: "370px",
                        marginLeft: "-8px",
                        marginTop: "-8px",
                      },
                      "& .MuiInputBase-input": {
                        "&::placeholder": {
                          fontSize: "16px",
                          fontWeight: "500",
                          padding: "0 4px",
                        },
                      },
                    }}
                    {...params}
                    variant="outlined"
                    placeholder="Select Schools"
                  />
                )}
              />
            </div>
          </div>
          <FormControl
            component="fieldset"
            variant="standard"
            className="mt-2 ml-2"
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={viewAccessList.smartclass}
                    onChange={handleChange}
                    name="smartclass"
                  />
                }
                label="Smartclass access"
              />
              <FormControlLabel
                label="Mathlab access"
                control={
                  <Switch
                    checked={viewAccessList.mathlab}
                    onChange={handleChange}
                    name="mathlab"
                  />
                }
              />
            </FormGroup>
          </FormControl>
          <div className="w-full flex justify-center p-10">
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#4CAF50",
                color: "white",
                "&:hover": {
                  backgroundColor: "#45a049",
                },
              }}
            >
              Submit
            </Button>
          </div>
        </Box>
      </Paper>
    </>
  );
}
